/** Chainage in road notation: 12340 m -> "km 12+340". */
export function chainage(m: number | null | undefined): string {
  if (m === null || m === undefined || Number.isNaN(m)) return "—";
  const km = Math.floor(m / 1000);
  const rest = Math.round(m - km * 1000);
  return `km ${km}+${String(rest === 1000 ? 999 : rest).padStart(3, "0")}`;
}

export function km(v: number | null | undefined, digits = 1): string {
  if (v === null || v === undefined) return "—";
  return `${v.toLocaleString("en-KE", { minimumFractionDigits: digits, maximumFractionDigits: digits })} km`;
}

export function num(v: number | null | undefined): string {
  return v === null || v === undefined ? "—" : v.toLocaleString("en-KE");
}

export function pct(v: number | null | undefined, digits = 0): string {
  if (v === null || v === undefined) return "—";
  return `${(v * 100).toFixed(digits)}%`;
}

export function date(v: string | null | undefined): string {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return v.slice(0, 10);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function dateTime(v: string | null | undefined): string {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return v.replace("T", " ").slice(0, 16);
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function ago(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return "no fix yet";
  if (seconds < 90) return `${seconds}s ago`;
  if (seconds < 5400) return `${Math.round(seconds / 60)} min ago`;
  if (seconds < 172800) return `${Math.round(seconds / 3600)} h ago`;
  return `${Math.round(seconds / 86400)} days ago`;
}

export const ROLE_LABEL: Record<string, string> = {
  viewer: "Viewer",
  engineer: "Engineer",
  surveyor: "Surveyor",
  admin: "Admin",
};
